export class UnauthorizedError extends Error {
}

export class ValidationError extends Error {
  constructor(message, errors = []) {
    super(message);
    this.errors = errors;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/errors.js